import SimpleUploadModal from "../Modals/SimpleUploadModal.js";
import { DefaultContainerNoClose } from "components/Structure/ModalManager/DefaultContainer.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { handleResetMailStatus } from "./uploaderAPI.js";
import { useCookie } from "contexts/cookieContext/cookieContext.js";

export const useUploaderErrorRedirect = ({
  setItsDone,
  setErrStatus,
  uploadedFiles,
  totalFiles,
}) => {
  const { setModal } = useModal();
  const { getHtmlByKey } = useContent();
  const { getMailId, getToken, uploaderCancelAll, setIsUppy, getIsUppy } =
    useUploader();
  const { setCookies, removeCookies } = useCookie();

  const redirectFunc = () => {
    if (window.location.href.includes("test.jumbomail")) {
      removeCookies("Test-NewUploader");
      setCookies("Test-NewUploader", false, {
        path: "/",
        domain: ".jumbomail.me",
      });
    } else {
      removeCookies("NewUploader");
      setCookies("NewUploader", false, {
        path: "/",
        domain: ".jumbomail.me",
      });
    }
    setIsUppy(false);
    // window.location.href = `${
    //   config.baseurl
    // }${getPath()}UploadJumbomail.aspx?sid=${getMailId()}`;
  };

  const handleRequest = async () => {
    setItsDone(true);
    await handleResetMailStatus({
      body: {
        MailEncryptedId: getMailId(),
        CSRFToken: getToken(),
        Runtime: getIsUppy() ? "Uppy" : "FU",
      },
      callback: redirectFunc,
    });
  };

  const getSubText = () => {
    if (uploadedFiles.length === 0) {
      return null;
    }
    if (uploadedFiles.length > 0) {
      return getHtmlByKey(
        "suggest-try-another-uploader-sub-text-files-uploaded"
      )
        .replace("#uploaded#", uploadedFiles.length)
        .replace("#expected#", totalFiles);
    }
  };

  const handleRedirectModal = () => {
    setModal({
      modal: SimpleUploadModal,
      container: DefaultContainerNoClose,
      props: {
        icon: { name: "warning", red: true },
        text: "suggest-try-another-uploader-text",
        subText: "suggest-try-another-uploader-sub-text",
        buttonText: "suggest-try-another-uploader-button-text",
        additionalText: getSubText(),
        buttonCallback: handleRequest,
        isCancel: true,
        cancelText: "close",
        cancelCallback: () => {
          uploaderCancelAll();
          setErrStatus(null);
        },
      },
    });
  };
  return handleRedirectModal;
};

export default useUploaderErrorRedirect;
